"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XIconCloseButton = void 0;
var xIconCloseButton_1 = require("./xIconCloseButton");
Object.defineProperty(exports, "XIconCloseButton", { enumerable: true, get: function () { return __importDefault(xIconCloseButton_1).default; } });
